import { api } from "./client";
import type { ThreadMessage } from "./threads";

// Case detail messages come without the contact-enriched `from` field.
export type CaseMessage = Omit<ThreadMessage, "from">;

export type CaseStatus = "open" | "closed";

export type CaseSummary = {
  id: string;
  caseId: string;
  title: string | null;
  summary: string | null;
  keywords: string[];
  tags: string[];
  status: CaseStatus;
  createdAt: string;
};

export type CaseDetail = {
  id: string;
  caseId: string;
  title: string | null;
  summary: string | null;
  keywords: string[];
  tags: string[];
  status: CaseStatus;
  gmailLabelId: string | null;
  matchedMessageId: string | null;
  createdAt: string;
  message: CaseMessage | null;
};

export function listCases(
  options: {
    status?: "all" | CaseStatus;
    limit?: number;
    q?: string;
    cursor?: string | null;
  } = {},
): Promise<{ cases: CaseSummary[]; nextCursor: string | null }> {
  const params = new URLSearchParams({
    status: options.status ?? "all",
    limit: String(options.limit ?? 50),
  });
  if (options.q) params.set("q", options.q);
  if (options.cursor) params.set("cursor", options.cursor);
  return api(`/cases?${params}`);
}

export function getCase(id: string): Promise<{ case: CaseDetail }> {
  return api(`/cases/${id}`);
}

export function resummarizeCase(id: string): Promise<{ ok: true }> {
  return api(`/cases/${id}/resummarize`, { method: "POST" });
}

export function setCaseStatus(id: string, status: CaseStatus): Promise<{ ok: true; status: CaseStatus }> {
  return api(`/cases/${id}`, { method: "PATCH", body: { status } });
}

export function setCaseTags(id: string, tags: string[]): Promise<{ ok: true; tags: string[] }> {
  return api(`/cases/${id}`, { method: "PATCH", body: { tags } });
}

export function listAllCaseTags(): Promise<{ tags: string[] }> {
  return api(`/cases/tags`);
}
